import axiosClient from './axiosClient';

const pushApi = {
    /**
     * Get VAPID public key
     */
    getVapidPublicKey: () => {
        const url = '/push/vapid-public-key';
        return axiosClient.get(url);
    },

    /**
     * Subscribe to push notifications
     * @param {Object} subscription - Push subscription object
     */
    subscribePush: (subscription) => {
        const url = '/push/subscription';
        return axiosClient.post(url, subscription);
    },

    /**
     * Update push subscription
     * @param {Object} subscription - Push subscription object
     */
    updatePushSubscription: (subscription) => {
        const url = '/push/subscription';
        return axiosClient.put(url, subscription);
    },

    /**
     * Unsubscribe from push notifications
     * @param {Object} subscription - Push subscription object with endpoint
     */
    unsubscribePush: (subscription) => {
        const url = '/push/subscription';
        return axiosClient.delete(url, { data: subscription });
    },

    /**
     * Get subscription status
     */
    getPushSubscriptionStatus: () => {
        const url = '/push/subscription/status';
        return axiosClient.get(url);
    },

    /**
     * Track notification read
     * @param {Object} data - { subscriber_id, notification_id, domain }
     */
    trackNotificationRead: (data) => {
        const url = '/push/tracking/read';
        const params = new URLSearchParams();
        if (data.subscriber_id) params.append('subscriber_id', data.subscriber_id);
        if (data.notification_id) params.append('notification_id', data.notification_id);
        if (data.domain) params.append('domain', data.domain);
        return axiosClient.post(`${url}?${params.toString()}`);
    },

    /**
     * Track notification click
     * @param {Object} data - { subscriber_id, notification_id, action, domain }
     */
    trackNotificationClick: (data) => {
        const url = '/push/tracking/click';
        const params = new URLSearchParams();
        if (data.subscriber_id) params.append('subscriber_id', data.subscriber_id);
        if (data.notification_id) params.append('notification_id', data.notification_id);
        if (data.action) params.append('action', data.action);
        if (data.domain) params.append('domain', data.domain);
        return axiosClient.post(`${url}?${params.toString()}`);
    },

    /**
     * Track notification close
     * @param {Object} data - { subscriber_id, notification_id, action, domain }
     */
    trackNotificationClose: (data) => {
        const url = '/push/tracking/close';
        const params = new URLSearchParams();
        if (data.subscriber_id) params.append('subscriber_id', data.subscriber_id);
        if (data.notification_id) params.append('notification_id', data.notification_id);
        if (data.action) params.append('action', data.action);
        if (data.domain) params.append('domain', data.domain);
        return axiosClient.post(`${url}?${params.toString()}`);
    },
};

export default pushApi;

